import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 50); // 14:50 in seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 0) {
          return 14 * 60 + 50; // Reset timer
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formatTime = (num: number) => num.toString().padStart(2, '0');
  if (timeLeft <= 0) {
    return <div className="fixed top-0 left-0 right-0 z-50 bg-green-700 text-white py-2.5 px-4 text-center font-bold" data-id="element-4">
        <span className="text-lg" data-id="element-5">⏳ OFERTA EXPIRADA</span>
      </div>;
  }
  return <div className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-green-700 to-emerald-600 text-white py-2.5 px-4 text-center font-bold" data-id="element-6">
      <span className="text-sm md:text-base" data-id="element-7">
        ⏳ OFERTA EXPIRA EN:{' '}
        <span className="bg-green-900/50 px-2 py-0.5 rounded mx-1 font-mono" data-id="element-8">
          {formatTime(minutes)}:{formatTime(seconds)}
        </span>{' '}
        | 🔥 CUPOS LIMITADOS
      </span>
    </div>;
}